export default {
  home: 'Inicio',
};
